import styled from 'styled-components';
import { colors, fontSizes, spacing, statusColors } from '../../../defaultTheme';
export const Container = styled.div `
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
`;
export const RadioInput = styled.input `
  opacity: 0;
  width: 0;
  margin: 0;
  padding: 0;
`;
export const Label = styled.label `
  position: relative;
  display: flex;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  flex-grow: 1;
`;
export const Chip = styled.label `
  box-sizing: border-box;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  cursor: ${({ disabled }) => (!disabled ? 'pointer' : 'not-allowed')};
  box-shadow: 0px 1px 2px ${colors.lightGrey};
  overflow: hidden;
  border-radius: 9999px;
  height: 32px;
  font-size: ${fontSizes.small}px;
  font-family: Open Sans;
  color: ${({ theme }) => theme.chip.text};
  user-select: none;
  padding: 0px ${spacing.base}px;
  margin-right: ${spacing.base}px;
  white-space: nowrap;

  ${RadioInput}:focus + & {
    outline: 2px solid ${({ theme }) => theme.radio.focusBackground};
  }

  &:hover {
    ${({ disabled, theme }) => !disabled ? `background-color: ${theme.chip.hover};` : ''}
  }

  &:after {
    ${({ disabled, theme }) => disabled
    ? ''
    : `
  content: '';
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
  background-image: radial-gradient(
    circle,
    ${theme.chip.animated} 10%,
    transparent 10%
  );
  background-repeat: no-repeat;
  background-position: 50%;
  transform: scale(10, 10);
  opacity: 0;
  transition: transform 0.5s, opacity 1s;
  `}
  }

  &:active:after {
    transform: scale(0, 0);
    opacity: 0.1;
    transition: 0s;
  }

  ${({ direction }) => {
    if (direction === 'column') {
        return `
        width: 100%;
        margin-right: 0px;
        margin-bottom:  ${spacing.base}px;
        justify-content: center;
      `;
    }
    return '';
}};

  ${({ checked, disabled, hasError }) => {
    if (disabled) {
        return `
        background-color: ${colors.lightGrey};
      `;
    }
    if (hasError) {
        return `
        background-color: ${statusColors.error.background};
        border: 1px solid ${statusColors.error.border};

        svg {
          color: ${statusColors.error.icon};
        }
      `;
    }
    if (checked) {
        return `
        background-color: ${statusColors.info.background};
        border: 1px solid ${statusColors.info.border};

        svg {
          color: ${statusColors.info.icon};
        }
      `;
    }
    return `
      background-color: ${colors.white};
      border: 1px solid ${colors.lightGrey};
    `;
}}
`;
export const ChipText = styled.p `
  font-size: ${fontSizes.root}px;
  text-align: center;
`;
export const RadioIcon = styled.span `
  width: 30px;
  height: 30px;
  border-radius: 100%;
  position: relative;
  flex-basis: 30px;
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: 5px;
  ${RadioInput}:focus ~ label > & {
    outline: 2px solid ${({ theme }) => theme.radio.focusBackground};
  }
`;
export const RadioIconOuterCircle = styled.span `
  box-sizing: border-box;
  border-radius: 50%;
  border: ${({ theme, hasError, disabled }) => {
    let borderColor;
    if (hasError) {
        borderColor = colors.error;
    }
    else if (disabled) {
        borderColor = theme.radio.inactiveBorder;
    }
    else {
        borderColor = theme.radio.border;
    }
    return `2px solid ${borderColor}`;
}};
  width: 20px;
  height: 20px;
  position: absolute;
  left: 5px;
  top: 5px;
`;
export const RadioIconInnerCircle = styled.span `
  position: absolute;
  background: ${({ theme, checked, disabled }) => {
    let bgColor;
    if (checked) {
        bgColor = disabled ? theme.radio.inactiveBorder : theme.radio.background;
    }
    else {
        bgColor = 'inherit';
    }
    return bgColor;
}};
  border-radius: 50%;
  width: 10px;
  height: 10px;
  top: 3px;
  left: 3px;
`;
//# sourceMappingURL=subcomponents.js.map